// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f5dd97ba","239":"50e40b2a","453":"004668b9","667":"41dbd6f8"}[chunkId] + ".chunk.js";
};